module.exports = __webpack_public_path__ + "static/media/tornado.1155f138.svg";